import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const BankDropdown = ({ id , placeholder , options , onChange , name , label , required =true , hideAsteriskSign =false  })=>{
    const [showMenu, setShowMenu] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(null);
    const inputRef = React.useRef(null);
    React.useEffect(()=>{
        const handler = (e)=>{
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                setShowMenu(false);
            }
        };
        window.addEventListener('click', handler);
        return ()=>{
            window.removeEventListener('click', handler);
        };
    });
    const handleInputClick = ()=>{
        setShowMenu(!showMenu);
    };
    const handleOnInputKeyDown = (e)=>{
        if ([
            'Enter',
            ' '
        ].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            handleInputClick();
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            setShowMenu(false);
        }
    };
    const onItemClick = (option)=>{
        setSelectedValue(option);
        onChange && onChange({
            label: option.label,
            value: option.value
        });
        setShowMenu(false);
    };
    const handleOnItemKeyDown = (e, option)=>{
        if ([
            'Enter',
            ' '
        ].includes(e.key)) {
            var ref;
            e.preventDefault();
            e.stopPropagation();
            onItemClick(option);
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
        if (e.key === 'Escape') {
            var ref1;
            e.preventDefault();
            e.stopPropagation();
            setShowMenu(false);
            (ref1 = inputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    const isSelected = (option)=>{
        if (!selectedValue) {
            return false;
        }
        return selectedValue.value === option.value;
    };
    const getOptions = ()=>{
        return Object.values(options);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "dropdown-field"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "dropdown-field__label",
        htmlFor: id,
        id: "dropdown-label"
    }, label, required && !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "dropdown-field__asterisk"
    }, "*")), /*#__PURE__*/ React.createElement("div", {
        className: "dropdown-field__container"
    }, /*#__PURE__*/ React.createElement("div", {
        id: id,
        ref: inputRef,
        onClick: handleInputClick,
        onKeyDown: handleOnInputKeyDown,
        className: "dropdown-field__input",
        role: "combobox",
        "aria-controls": name,
        "aria-expanded": showMenu,
        "aria-labelledby": "dropdown-label",
        tabIndex: 0
    }, !selectedValue ? /*#__PURE__*/ React.createElement("div", {
        className: "dropdown-field__placeholder"
    }, placeholder) : /*#__PURE__*/ React.createElement("div", {
        className: "dropdown-field__value"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "dropdown-field__bank-icon"
    }, selectedValue.icon), selectedValue.label)), /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down",
        className: "select-field__icon"
    })), showMenu && /*#__PURE__*/ React.createElement("div", {
        className: "dropdown-field__menu"
    }, getOptions().map((option)=>/*#__PURE__*/ React.createElement("div", {
            onClick: ()=>onItemClick(option)
            ,
            key: option.value,
            className: `dropdown-item ${isSelected(option) && 'selected'}`,
            onKeyDown: (event)=>handleOnItemKeyDown(event, option)
            ,
            role: "option",
            "aria-selected": isSelected(option),
            tabIndex: 0
        }, /*#__PURE__*/ React.createElement("div", {
            className: "dropdown-field__bank-icon"
        }, option.icon), option.label)
    )));
};

export { BankDropdown as default };
//# sourceMappingURL=BankDropDown.js.map
